const TabGroupLeftVerticalHeader = ({ children }) => {
  return (
    <div className="col-5 col-sm-3">
      <div
        className="nav flex-column"
        id="vert-tabs-tab"
        role="tablist"
        aria-orientation="vertical"
        style={{
          gap: "4px",
          paddingRight: "8px",
          borderRight: "2px solid #f0f0f0",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default TabGroupLeftVerticalHeader;
